import {
    useLicenseController_createNewLicenseForClient,
    useLicenseController_deleteClientLicenses,
    useLicenseController_getClientLicenses,
    useLicenseController_getLicense,
    useLicenseController_updateClientLicense,
} from '@/services/hooks';
import type { LicenseInfo } from '@/services/types';

import { type DomainMutation, ignoreBody, useMappedMutation } from '../shared/mutation';
import { type DomainQuery, useMappedQuery } from '../shared/query';

import { toClientLicenses, toList } from './mappers';
import type { ClientLicense, NewClientLicense } from './types';

/** Every licence that exists. */
export function useGetLicenseCatalogue(): DomainQuery<LicenseInfo[]> {
    return useMappedQuery(useLicenseController_getLicense(), toList);
}

/** The licence seats a client holds. */
export function useGetClientLicenses(clientId: number): DomainQuery<ClientLicense[]> {
    return useMappedQuery(useLicenseController_getClientLicenses(clientId), toClientLicenses);
}

function newClientLicenseToApi(license: NewClientLicense) {
    return { requestBody: license };
}

function seatsToApi({ id, numLicenses }: { id: number; numLicenses: number }) {
    return { id, requestBody: { numLicenses } };
}

function byId({ id }: { id: number }) {
    return { id };
}

export function useAddClientLicense(): DomainMutation<NewClientLicense, void> {
    return useMappedMutation(
        useLicenseController_createNewLicenseForClient(),
        newClientLicenseToApi,
        ignoreBody
    );
}

export function useUpdateClientLicense(): DomainMutation<
    { id: number; numLicenses: number },
    void
> {
    return useMappedMutation(useLicenseController_updateClientLicense(), seatsToApi, ignoreBody);
}

export function useDeleteClientLicense(): DomainMutation<{ id: number }, void> {
    return useMappedMutation(useLicenseController_deleteClientLicenses(), byId, ignoreBody);
}
